import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { DzIconModule } from '@blk/daisy/core/icon';
import { GenericDirectivesModule, InjectQueryParam } from '@ddt-web/generic-utils';
import { DebugQueryParamKey, UrlUtils } from '@ddt-web/url';

import { BuildInfoComponent } from './components/build-info/build-info.component';
import { InfoBubbleComponent } from './components/info-bubble/info-bubble.component';
import { ModalComponent } from './components/modal/modal.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { DomService } from './services/dom.service';

declare let console;

@NgModule({
	imports: [CommonModule, DzIconModule, DzTooltipModule, GenericDirectivesModule],
	declarations: [BuildInfoComponent, ModalComponent, TooltipDirective, InfoBubbleComponent],
	exports: [BuildInfoComponent, ModalComponent, TooltipDirective, InfoBubbleComponent]
})
export class DomModule {

	@InjectQueryParam(DebugQueryParamKey.SHOW_EDITOR) private readonly showEditorQp: boolean = false;
	@InjectQueryParam(DebugQueryParamKey.BUILD_INFO) private readonly buildInfoQp: boolean = false;
	@InjectQueryParam(DebugQueryParamKey.LOG) private readonly logQp: boolean = false;

	constructor(private domService: DomService, @Optional() @SkipSelf() parentModule: DomModule) {
		if (!parentModule && (this.showEditorQp || this.buildInfoQp)) {
			this.domService.appendComponentToBody(BuildInfoComponent);
		}

		const shouldDisableConsoleLogs = !(this.showEditorQp || this.logQp || UrlUtils.isLocalhost());
		if (shouldDisableConsoleLogs) {
			// Taken from https://developer.mozilla.org/en-US/docs/Web/API/console
			const methods = ['clear', 'debug', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeLog', 'timeStamp'];
			methods.forEach(method => {
				console[method] = () => { };
			});
		}
	}
}

